import React from 'react';
import { Star } from 'lucide-react';
import './TestimonialCard.css';

const TestimonialCard = ({ name, company, text, image }) => {
  return (
    <div className="testimonial-card">
      <div className="testimonial-stars">
        {[...Array(5)].map((_, i) => (
          <Star key={i} size={18} fill="var(--secondary-color)" color="var(--secondary-color)" />
        ))}
      </div>
      <p className="testimonial-text">"{text}"</p>
      <div className="testimonial-author">
        {image && (
          <img src={image} alt={name} className="author-image" />
        )}
        <div className="author-info">
          <p className="author-name">{name}</p>
          <p className="author-company">{company}</p>
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;